import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { updateGeneratedTextInputContent } from '../../../canvas-elements/element-model/generated-field-props';
import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateTextFieldFormField(
  params: FormFieldGenerationParams<'textField'>,
): PartialPropsOf<'textField'> {
  let props: PartialPropsOf<'textField'> = updateGeneratedTextInputContent(
    params.inputData,
    params.props,
  );

  props = applyPropsPatch(props, {
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  return props;
}
